import { render, staticRenderFns } from "./AdminRecord.vue?vue&type=template&id=aac084a0&scoped=true"
import script from "./AdminRecord.vue?vue&type=script&lang=js"
export * from "./AdminRecord.vue?vue&type=script&lang=js"
import style0 from "./AdminRecord.vue?vue&type=style&index=0&id=aac084a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac084a0",
  null
  
)

export default component.exports